import { ShareRoute } from '@/system-modules/share/v1/api/ShareRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { IViewer } from '@/contracts/system-modules/share/IViewer'
import { SetViewerParams } from '@/system-modules/share/v1/api/v1/share/SetViewer/Dto/SetViewerParams'

export class SetViewerRoute extends ShareRoute<SetViewerParams, IViewer> {
  constructor(private readonly viewerUuid: string) {
    super()
  }

  type(): EnumRouteType {
    return EnumRouteType.PUT
  }

  url(): string {
    return '/api/system/v1/share/viewers/' + this.viewerUuid
  }

  /** Без сервера набор зон считается принятым */
  offline(params: SetViewerParams): Promise<ApiResponse<IViewer>> {
    return Promise.resolve(new ApiResponse({ success: true, data: { viewerUuid: this.viewerUuid, zones: params.zones } }))
  }
}
